import { useResourceValue } from '@composables'
import { Settings } from '@config/game.js'
import { userStatsStore } from '@stores'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import {
  USER_GUIDE_BROWSE_ROUTE,
  USER_MOD_BROWSE_ROUTE,
} from '@config/routeNames.js'

export default function (nameId, gameRoute = false) {
  const { getUserStats } = userStatsStore()

  const userStats = getUserStats(nameId, gameRoute)
  const { t } = useI18n()

  const modTotal = computed(() => userStats.value?.mod_count || 0)
  const guideTotal = computed(() => userStats.value?.guide_count || 0)
  const subsTotal = computed(() => userStats.value?.follower_count || 0)

  const userTotals = computed(() => {
    const totals = [
      {
        stat: modTotal.value,
        text: `${useResourceValue().ugcName().value} ${t('created')}`,
        icon: 'cubes',
      },
      {
        stat: subsTotal.value,
        text: t('followers'),
        icon: 'users',
      },
    ]

    if (Settings.value.showGuides) {
      totals[0].route = USER_MOD_BROWSE_ROUTE
      totals.splice(1, 0, {
        stat: guideTotal.value,
        text: `${t('guide', 2)} ${t('created')}`,
        icon: 'book-open',
        route: USER_GUIDE_BROWSE_ROUTE,
      })
    }

    return totals
  })

  return {
    userTotals,
    guideTotal,
    subsTotal,
    modTotal,
  }
}
